import { IStore } from 'store/types';

export const selectDaySegments = () => (state: IStore) => state?.collections?.daySegments;
export const selectDaySegmentById = (daySegmentId: string) => (state: IStore) => state?.collections?.daySegments?.data?.find((daySegment) => daySegment.id === daySegmentId);
